// src/blocks/divider/divider.tsx
import { jsx } from "react/jsx-runtime";
var Divider = ({ className, id }) => {
  return /* @__PURE__ */ jsx("div", { className, id, children: /* @__PURE__ */ jsx("hr", { "aria-label": "divider" }) });
};
var divider_default = Divider;

export {
  divider_default
};
